export default __webpack_public_path__ + "static/media/ADNOCTextLogo.7bbf4000.svg";